import React from 'react'

function TenderTextFloor() {
    return (
        <embed src="\pdfs\EAT1.3.1_DB-E-DN_Floor_twist_outlets_kr.pdf" width="100%" height="2100px" />
    )
}

export default TenderTextFloor